// extracted by mini-css-extract-plugin
export default {"content_flex":"ConceptComponent_content_flex__dN2tu","right":"ConceptComponent_right__ky48o","left":"ConceptComponent_left__Onfs4","card":"ConceptComponent_card__oy+EY"};